let default_device = {
  'fever_alert': {
    'type': 'fever_alert',
    'sup_or_inf': 'sup',
    'threshold': {
      'defaut': 38.4,
      'min': 25.00,
      'max': 42.00,
      'step': 0.1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': 34,
      'min': 25.00,
      'max': 42.00,
      'step': 0.1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    }
  },
  'pulseRateAlertOxymetre': {
    'type': 'PR_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 100,
      'min': 20.0,
      'max': 300.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': 50,
      'min': 20.0,
      'max': 300.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    }
  },
  'spo2Alert': {
    'type': 'SPO2_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 90,
      'min': 0.0,
      'max': 100.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': 90,
      'min': 0.0,
      'max': 100.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    }
  },
  'pulseRateAlertTension': {
    'type': 'bloodpressure_PR_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 100,
      'min': 20.0,
      'max': 300.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': 50,
      'min': 20.0,
      'max': 300.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    }
  },
  'systolicHighAlert': {
    'type': 'bloodpressure_sys_high_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 120,
      'min': 20.0,
      'max': 300.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': 70,
      'min': 20.0,
      'max': 300.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    }
  },
  'diastolicHighAlert': {
    'type': 'bloodpressure_sys_high_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 90,
      'min': 20.0,
      'max': 300.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': 80,
      'min': 20.0,
      'max': 300.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    }
  },
   'weightAlert': {
    'type': 'weight_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 100,
      'min': 20.0,
      'max': 120.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': 40,
      'min': 20.0,
      'max': 120.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    }
  },
   'eq5dAlert': {
    'type': 'eq5d_alert',
    'sup_or_inf': 'inf',
    'sup_or_inf2': 'sup',
    'threshold': {
      'defaut': 4,
      'min': 0.0,
      'max': 10.00,
      'step': 0.1,
      'precision': 0.1,
      'value': null
    },
    'threshold2': {
      'defaut': 40,
      'min': 20.0,
      'max': 120.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    }
  },
   'eq5dScaleAlert': {
    'type': 'eq5d_scale_alert',
    'sup_or_inf': 'inf',
    'sup_or_inf2': 'sup',
    'threshold': {
      'defaut': 75,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': 75,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    }
  },
  'sf36Alert': {
    'type': 'sf36_alert',
    'sup_or_inf': 'inf',
    'sup_or_inf2': 'sup',
    'threshold': {
      'defaut': 4,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 0.1,
      'value': null
    },
    'threshold2': {
      'defaut': 40,
      'min': 20.0,
      'max': 120.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
  },
  'mdasiAlert': {
    'type': 'mdasi_alert',
    'sup_or_inf': 'inf',
    'sup_or_inf2': 'sup',
    'threshold': {
      'defaut': 6,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 0.1,
      'value': null
    },
    'threshold2': {
      'defaut': 40,
      'min': 20.0,
      'max': 120.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
  },
  'painAlert': {
    'type': 'pain_alert',
    'sup_or_inf': 'inf',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 4,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 0.1,
      'value': null
    },
    'threshold2': {
      'defaut': 40,
      'min': 20.0,
      'max': 120.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
  },
  'breathingAlert': {
    'type': 'breathing_rate_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 30,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': 20,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
  },
  'breathingOxygenRateAlert': {
    'type': 'breathing_oxygen_rate_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 6,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 0.1,
      'value': null
    },
    'threshold2': {
      'defaut': 1,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 0.1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
  },
  'breathingLeakageAlert': {
    'type': 'breathing_leakage_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 24,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 0.1,
      'value': null
    },
    'threshold2': {
      'defaut': 1,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 0.1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
  },
  'breathingLeakage95Alert': {
    'type': 'breathing_leakage95_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 24,
      'min': 0.0,
      'max': 500.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': null,
      'min': 0.0,
      'max': 500.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
  },
  'breathingAhiAlert': {
    'type': 'breathing_ahi_alert',
    'sup_or_inf': 'sup',
    'sup_or_inf2': 'inf',
    'threshold': {
      'defaut': 15,
      'min': 0.0,
      'max': 200.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'threshold2': {
      'defaut': null,
      'min': 0.0,
      'max': 200.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
  },
  'breathingObservanceAlert': {
    'type': 'breathing_observance_alert',
    'sup_or_inf': 'inf',
    'sup_or_inf2': 'sup',
    'threshold': {
      'defaut': 6,
      'min': 0.0,
      'max': 24.00,
      'step': 1,
      'precision': 0.1,
      'value': null
    },
    'threshold2': {
      'defaut': 1,
      'min': 0.0,
      'max': 100.00,
      'step': 1,
      'precision': 0.1,
      'value': null
    },
    'delay': {
      'defaut': 0,
      'min': 0.0,
      'max': 1000.0,
      'step': 1,
      'precision': 1,
      'value': null
    },
  }
}

module.exports = default_device;